import { Box, Typography } from '@mui/material';

import { AvoidPageBreakInsideWrapper, DealBuilderHeader } from '@styles/StyledDiv';

import { SectionTitle } from '@shared/components/SectionTitle';
import { BorderWrapper } from '@styles/CommonStyles';
import { IScoreCards } from './interfaces/interfaces';

export const ScoreCards = ({ scoreCards }: IScoreCards) => (
  <AvoidPageBreakInsideWrapper>
    <Box marginBottom={2}>
      <SectionTitle title="Score Cards" fontWeight={600} />
      
      <BorderWrapper sx={{ padding: '10px'}}>
        <div>
          {scoreCards &&
            (scoreCards.length > 0
              ? scoreCards?.map((score, index) => {
                  return (
                    <div key={index}>
                      <DealBuilderHeader>
                        <Typography>Scorecard</Typography>
                        <div style={{ width: '80%' }}>
                          {score.scoreType} {score.scoreCard}
                        </div>
                      </DealBuilderHeader>
                      <DealBuilderHeader>
                        <Typography style={{ verticalAlign: 'top', alignItems: 'flex-start' }}>
                          Reason
                        </Typography>
                        <div style={{ width: '80%' }}>
                          {score?.scoreCardReasons?.map((reason) => (
                            <div key={reason.code}>
                              {reason.code} {reason.codeReason}
                            </div>
                          ))}
                        </div>
                      </DealBuilderHeader>
                    </div>
                  );
                })
              : 'No Records found')}
        </div>
      </BorderWrapper>
    </Box>
  </AvoidPageBreakInsideWrapper>
);
